import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { useHistory } from 'react-router-dom';
import {
  CHECKAUTH_QUERY,
  INTERMEDIARY_LIST,
  VIEW_QUOTE_HEALTH,
} from './queries';
import {
  updateHealthQuote,
  updateHealthQuotePlans,
  resetPlansChanged,
} from 'quanta-flows/modules/quote/health/state';//'../capture-details/health/_graphql/state';
//import Loading from '../../../lib/layout/loading';
//import Error from '../../../lib/layout/error';
//import CaptureHealthDetails from '../capture-details/health';
import CaptureHealthDetailsSCPA from '../capture-details/health/SCPA';
import {useFetchQuery} from 'quanta-flows';
//import useFetchQuery from '../../../lib/graphql/useFetchQuery';
import { QUERY_STATE } from 'quanta-flows/modules/quote/health';//'../capture-details/health/queries';
//import { ClientService, Layout } from '../../../lib/layout';
import { Layout ,Error,  Loading } from 'quanta-flows/modules/layout';
import { ClientService } from 'quanta-flows/modules/layout';
import { useResponsiveParams, Card, Text } from 'quanta-ui';

export default function ViewQuoteDetailsHealth() {
  const { quote_number } = useParams();
  const fetchQuery = useFetchQuery();
  const history = useHistory();
  const reformData = (val, returnType, isString) => {
    return val && val.toString().trim() !== ''
      ? isString === undefined || isString === true
        ? `${val}`
        : val
      : returnType;
  };

  const textSize = useResponsiveParams({
    for_desktop: '3xl',
    for_mobile: '2xl',
    for_iPad: '3xl',
  });

  const {
    loading: loadingMyIntermediaries,
    error: errorMyIntermediaries,
    data: dataMyIntermediaries,
  } = useQuery(INTERMEDIARY_LIST);
  const {
    loading: loadingRole,
    error: errorRole,
    data: dataRole,
  } = useQuery(CHECKAUTH_QUERY, {
    fetchPolicy: 'cache-first',
  });

  const { loading, error, data } = useQuery(VIEW_QUOTE_HEALTH, {
    variables: {
      input: {
      quoteNumber: quote_number,
      },
    },
    onCompleted: async (data) => {
      const healthQuoteOutput = fetchQuery({
        query: QUERY_STATE,
      });
      let { data: healthQuoteData } = await healthQuoteOutput;

      updateHealthQuote({
        ...healthQuoteData?.healthQuote,
        currentTab: 'plans',
        captureMode: 'view',
        quoteCreationDate: data?.viewQuote?.quoteCreationDate,
        proposalNumber: data?.viewQuote?.proposalNumber,
        intermediaryDetails: {
          code: data?.viewQuote?.intermediaryDetails?.code
            ? `${data?.viewQuote?.intermediaryDetails?.code}`
            : '',
          name: data?.viewQuote?.intermediaryDetails?.name
            ? `${data?.viewQuote?.intermediaryDetails?.name}`
            : '',
          location: data?.viewQuote?.intermediaryDetails?.location
            ? `${data?.viewQuote?.intermediaryDetails?.location}`
            : '',
          fieldUserCode: data?.viewQuote?.intermediaryDetails
            ?.fieldUserCode
            ? `${data?.viewQuote?.intermediaryDetails?.fieldUserCode}`
            : '',
          fieldUserName: data?.viewQuote?.intermediaryDetails
            ?.fieldUserName
            ? `${data?.viewQuote?.intermediaryDetails?.fieldUserName}`
            : '',
        },
        customer: {
          id: data?.viewQuote?.customer?.cust_number,
          customerType: data?.viewQuote?.customer?.cust_type?.code,
          orgName: reformData(
            data?.viewQuote?.customer?.org_detail?.org_name,
            '',
          ),
          orgType: reformData(
            data?.viewQuote?.customer?.org_detail?.org_type?.code,
            '',
          ),
          contactName: reformData(
            data?.viewQuote?.customer?.org_detail?.contact_name,
            '',
          ),
          title: reformData(
            data?.viewQuote?.customer?.indv_detail?.title?.code,
            '',
          ),
          gender: reformData(
            data?.viewQuote?.customer?.gender?.code,
            '',
          ),
          proposerDOB: reformData(
            data?.viewQuote?.customer?.indv_detail?.date_of_birth,
            '',
          ),
          firstName: reformData(
            data?.viewQuote?.customer?.indv_detail?.first_name,
            '',
          ),
          middleName: reformData(
            data?.viewQuote?.customer?.indv_detail?.middle_name,
            '',
          ),
          fullName: reformData(
            data?.viewQuote?.customer?.indv_detail?.full_name,
            '',
          ),
          lastName: reformData(
            data?.viewQuote?.customer?.indv_detail?.surname,
            '',
          ),
          nationality: reformData(
            data?.viewQuote?.customer?.indv_detail?.nationality?.code,
            '',
          ),
          occupation: reformData(
            data?.viewQuote?.customer?.indv_detail?.occupation?.code,
            '',
          ),
          maritalStatus: reformData(
            data?.viewQuote?.customer?.indv_detail?.marital_status
              ?.code,
            '',
          ),
          panNumber: reformData(
            data?.viewQuote?.customer?.indv_detail?.pan_card_number,
            '',
          ),
          idProofType: reformData(
            data?.viewQuote?.customer?.indv_detail?.id_proof_type
              ?.code,
            '',
          ),
          idProofNumber: reformData(
            data?.viewQuote?.customer?.indv_detail?.id_proof_number,
            '',
          ),
          permAddressLine1: reformData(
            data?.viewQuote?.customer?.permanent_address
              ?.address_line1,
            '',
          ),
          permAddressLine2: reformData(
            data?.viewQuote?.customer?.permanent_address
              ?.address_line2,
            '',
          ),
          permAddressLine3: reformData(
            data?.viewQuote?.customer?.permanent_address
              ?.address_line3,
            '',
          ),
          permLandmark: reformData(
            data?.viewQuote?.customer?.permanent_address?.land_mark,
            '',
          ),
          permPincode: reformData(
            data?.viewQuote?.customer?.permanent_address?.pin_code,
            '',
          ),
          permCityTownVillage: reformData(
            data?.viewQuote?.customer?.permanent_address?.city,
            '',
          ),
          permDistrict: reformData(
            data?.viewQuote?.customer?.permanent_address?.district,
            '',
          ),
          permState: reformData(
            data?.viewQuote?.customer?.permanent_address?.state,
            '',
          ),
          permCommAddressYN: data?.viewQuote?.customer
            ?.comm_equal_perm
            ? true
            : false,
          commAddressLine1: reformData(
            data?.viewQuote?.customer?.communication_address
              ?.address_line1,
            '',
          ),
          commAddressLine2: reformData(
            data?.viewQuote?.customer?.communication_address
              ?.address_line2,
            '',
          ),
          commAddressLine3: reformData(
            data?.viewQuote?.customer?.communication_address
              ?.address_line3,
            '',
          ),
          commLandmark: reformData(
            data?.viewQuote?.customer?.communication_address
              ?.land_mark,
            '',
          ),
          commPincode: reformData(
            data?.viewQuote?.customer?.communication_address
              ?.pin_code,
            '',
          ),
          commCityTownVillage: reformData(
            data?.viewQuote?.customer?.communication_address?.city,
            '',
          ),
          commDistrict: reformData(
            data?.viewQuote?.customer?.communication_address
              ?.district,
            '',
          ),
          commState: reformData(
            data?.viewQuote?.customer?.communication_address?.state,
            '',
          ),
          emailID: reformData(
            data?.viewQuote?.customer?.contact?.email,
            '',
          ),
          mobileNo: reformData(
            data?.viewQuote?.customer?.contact?.mobile,
            '',
          ),
          phoneNo: reformData(
            data?.viewQuote?.customer?.contact?.telephone,
            '',
          ),
          faxNo: reformData(
            data?.viewQuote?.customer?.contact?.fax_number,
            '',
          ),
          altPhoneNo: reformData(
            data?.viewQuote?.customer?.contact?.alt_telephone,
            '',
          ),
          altMobileNo: reformData(
            data?.viewQuote?.customer?.contact?.alt_mobile,
            '',
          ),
          regNumber: reformData(
            data?.viewQuote?.customer?.org_detail?.reg_number,
            '',
          ),
          tanNumber: reformData(
            data?.viewQuote?.customer?.org_detail?.tan_number,
            '',
          ),
          gstNumber: reformData(
            data?.viewQuote?.customer?.org_detail?.gst_number ||
              data?.viewQuote?.customer?.indv_detail?.gst_number,
            '',
          ),
        },
        customerMeta: {
          crn: reformData(
            data?.viewQuote?.customer?.cust_ref_number,
            '',
          ),
          isNewCustomer: data?.viewQuote?.customer?.cust_number
            ? false
            : true,
          ifscCode: reformData(
            data?.viewQuote?.customer?.bank_detail?.ifsc_code,
            '',
          ),
          bankName: reformData(
            data?.viewQuote?.customer?.bank_detail?.name,
            '',
          ),
          branchName: reformData(
            data?.viewQuote?.customer?.bank_detail?.branch_name,
            '',
          ),
          bankAcno: reformData(
            data?.viewQuote?.customer?.bank_detail?.acc_number,
            '',
          ),
          accountHolderName: reformData(
            data?.viewQuote?.customer?.bank_detail?.acc_holder,
            '',
          ),
          micrCode: reformData(
            data?.viewQuote?.customer?.bank_detail?.micr_code,
            '',
          ),
        },
        location: data?.viewQuote?.location,
        members: data?.viewQuote?.members?.map((mem) => {
          return {
            relationship: mem?.relationship,
            age: mem?.age,
            gender: mem?.gender,
            dob: mem?.dob,
            selected: true,
          };
        }),
        cover: {
          type: data?.viewQuote?.cover?.type,
          sum_insured: `${data?.viewQuote?.cover?.sumInsured}`,
          tenure: data?.viewQuote?.cover?.tenure,
        },
        quotationNo: data?.viewQuote?.quoteNumber,
        quotationStatus: data?.viewQuote?.quoteStatus,
        quotationType: data?.viewQuote?.quotationType,
        existingPolicyNumber: data?.viewQuote?.existingPolicyNumber,
        isExistingEmployee: data?.viewQuote?.isExistingEmployee
          ? 'Yes'
          : 'No',
        intermediaryDetails: data?.viewQuote?.intermediaryDetails,
        deductSumInsured:data?.viewQuote?.deductSumInsured,
      });
      updateHealthQuotePlans(data?.viewQuote?.plans,true);
      resetPlansChanged();
    },
  });

  return loading || loadingMyIntermediaries || loadingRole ? (
    <Loading />
  ) : error || errorMyIntermediaries || errorRole ? (
    <Error
      error={{
        message: `There was an issue fetching the Quote Details`,
      }}
    />
  ) : data &&
    dataMyIntermediaries?.myIntermediaries?.find(
      (myIntermediary) =>
        myIntermediary?.intermediaryCode
          ?.toString()
          ?.toLowerCase() ===
        data?.viewQuote?.intermediaryDetails?.code
          ?.toString()
          ?.toLowerCase(),
    ) &&
    (dataRole.checkAuth.role.roleName?.toString()?.toLowerCase() !==
      'underwriter' ||
      (dataRole.checkAuth.role.roleName?.toString()?.toLowerCase() ===
        'underwriter' &&
        [
          'pending uw approval',
          'underwriter approved',
          'underwriter rejected',
        ]?.includes(
          data?.viewQuote?.status?.toString()?.toLowerCase(),
        ))) ? 
        (
    <CaptureHealthDetailsSCPA
      productName={data.viewQuote.product.productName}
      productCode={data.viewQuote.product.productCode}
      lobCode={data.viewQuote.lob.lobCode}
      quoteNumber={quote_number}
      breadcrumbNav={['Quote', 'View Quote']}
    />
  ) : data &&
    !dataMyIntermediaries?.myIntermediaries?.find(
      (myIntermediary) =>
        myIntermediary?.intermediaryCode
          ?.toString()
          ?.toLowerCase() ===
        data?.viewQuote?.intermediaryDetails?.code
          ?.toString()
          ?.toLowerCase(),
    ) ? (
    <Layout
      nav={['Quote', 'View Quote']}
      service_type={ClientService}
      title={`Your ${data?.viewQuote?.product?.productName} Quote`}
    >
      <Card className="h-screen" severity={`error`}>
        <Text
          severity={'error'}
          className={`w-full h-full text-center text-${textSize} flex items-center justify-center`}
        >
          Access denied.You are not allowed to view quote belonging to
          another intermediary.
        </Text>
      </Card>
    </Layout>
  ) : dataRole.checkAuth.role.roleName?.toString()?.toLowerCase() ===
      'underwriter' &&
    ![
      'pending uw approval',
      'underwriter approved',
      'underwriter rejected',
    ]?.includes(
      data?.viewQuote?.status?.toString()?.toLowerCase(),
    ) ? (
    <Layout
      nav={['Quote', 'View Quote']}
      service_type={ClientService}
      title={`Your ${data?.viewQuote?.product?.productName} Quote`}
    >
      <Card className="h-screen" severity={`error`}>
        <Text
          severity={'error'}
          className={`w-full h-full text-center text-${textSize} flex items-center justify-center`}
        >
          Quote is invalid or not belonging to UW approved, UW
          rejected or pending for UW approval
        </Text>
      </Card>
    </Layout>
  ) : null;
}
